export const hasParentClass = ( el, classname ) => {
  if(el === document) return false;
  if( el.classList.contains( classname ) ) {
    return true;
  }
  return el.parentNode && hasParentClass( el.parentNode, classname );
};

export const domParserSupport = () => {
  if (!window.DOMParser) return false;
  let parser = new DOMParser();
  try {
    parser.parseFromString('x', 'text/html');
  } catch(err) {
    return false;
  }
  return true;
};

export const camelCaseToDash = srt => {
  return srt.replace( /([a-z])([A-Z])/g, '$1-$2' ).toLowerCase();
}

export const createElement = (options) =>
{
  let tagname = options.tagname || 'div';
  let el = document.createElement(tagname);
  if (options.classes) {
    el.classList.add(...options.classes);
  }

  if (options.attributes) {
    for (const [key, value] of Object.entries(options.attributes)) {
      el.setAttribute(camelCaseToDash(key), String(value));
    }
  }

  if(options.dataset) {
    for (const [key, value] of Object.entries(options.dataset)) {
      el.dataset[key] = value;
    }
  }

  if(options.textContent) {
    el.textContent = options.textContent;
  }

  if(options.innerHTML) {
    el.innerHTML = options.innerHTML;
  }

  if(options.parent) {
    options.parent.appendChild(el);
  }

  return el;
}



export const serializeArray = form =>
{
  let arr = [];
  Array.prototype.slice.call(form.elements).forEach(function (field) {
    if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) {
      return;
    }
    if (field.type === 'select-multiple') {
      Array.prototype.slice.call(field.options).forEach(function (option) {
        if (!option.selected) return;
        arr.push({
          name: field.name,
          value: option.value,
        });
      });
      return;
    }
    if (['checkbox', 'radio'].indexOf(field.type) >-1 && !field.checked) return;
    arr.push({
      name: field.name,
      value: field.value,
    });
  });

  return arr;
};

export const memoize = fn => {
  const cache = new Map();
  return (...args) => {
    const strX = JSON.stringify(args);
    if (!cache.has(strX)) {
      cache.set(
        strX,
        fn(...args).catch((err) => {
          cache.delete(strX);
          return false;
        })
      );
    }
    return cache.get(strX);
  };
};

// Strip whitespace (or other characters) from the end of a string

export const rtrim = ( str, charlist = '' ) => {
  charlist = !charlist ? ' \s\xA0' : charlist.replace(/([\[\]\(\)\.\?\/\*\{\}\+\$\^\:])/g, '\$1');
  let re = new RegExp('[' + charlist + ']+$', 'g');
  return str.replace(re, '');
}

//Get query var from url

export const getQueryParam = key => {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  return params[key];
}
